import React from 'react';
import PropTypes from 'prop-types';
import { FlatButton } from 'material-ui';
import { Labeled } from 'admin-on-rest/lib/mui';
import { FieldArray, Field } from 'redux-form';
import AddIcon from 'material-ui/svg-icons/content/create';
import DeleteIcon from 'material-ui/svg-icons/action/delete';

const rowStyle = {
  margin: '1em',
  display: 'flex',
  width: '100%',
  flexWrap: 'wrap',
};

const inputStyle = {
  flexGrow: '1',
  flexShrink: '1',
  padding: '0 1em 1em 1em',
};

class Seasons extends React.Component {
  renderSeasons = ({ fields }) => {
    const { children } = this.props;

    return (
      <div>
        {
          fields.map((season, i) => {
            return (
              <div key={`season${i}`}>
                <div style={rowStyle}>
                  {React.Children.map(children, input => input && (
                    <div
                      key={input.props.source}
                      className={`aor-input-${input.props.source}`}
                      style={inputStyle}
                    >
                      <Field {...input.props} name={`${season}.${input.props.source}`} component={input.type} />
                    </div>
                  ))}
                  <FlatButton
                    label="Remove"
                    icon={<DeleteIcon />}
                    onClick={() => fields.remove(i)}
                    style={inputStyle}
                  />
                </div>
              </div>

            );
          })
        }
        <FlatButton
          label="Προσθεσε επιλογες"
          icon={<AddIcon />}
          onClick={() => fields.push({
            id: Date.now()
          })}
        />
      </div>
    );
  }

  render() {
    const { source } = this.props;
    return (
      <Labeled label="επιλογες">
        <FieldArray name={source} component={this.renderSeasons} />
      </Labeled>
    );

  }
}

Seasons.propTypes = {
  addField: PropTypes.bool.isRequired,
  allowEmpty: PropTypes.bool.isRequired,
  basePath: PropTypes.string,
  children: PropTypes.node,
  label: PropTypes.string,
  meta: PropTypes.object,
  onChange: PropTypes.func,
  input: PropTypes.object,
  resource: PropTypes.string,
  source: PropTypes.string,
};

Seasons.defaultProps = {
  addField: false,
  allowEmpty: false,
};

export default Seasons;



// WEBPACK FOOTER //
// ./src/pages/custom/Seasons.js